<script>
  import { createEventDispatcher } from 'svelte';

  import Avatar from '@components/Avatar.svelte';
  import Button from '@components/Button.svelte';
  import Textarea from '@components/Textarea.svelte';
  import RecRequestAjax from '@ajax/rec_request';

  const dispatch = createEventDispatcher();

  export let group;
  export let recRequest;
  export let currentUser;
  export let close;
  export let apiRequest;
  export let mobile = false;

  let saving = false;

  if (!recRequest.thank_you_message) {
    recRequest.thank_you_message = `Thank you very much for the recommendations. Really appreciate it!`;
  }

  let save = function () {
    saving = true;

    apiRequest(
      {
        rec_request: {
          respondents_can_set_private_recs: recRequest.respondents_can_set_private_recs,
          thank_you_message: recRequest.thank_you_message,
          respondents_can_view_list_of_recommendations: recRequest.respondents_can_view_list_of_recommendations,
        },
      },
      async () => {
        await RecRequestAjax.markActive(group, recRequest);
        saving = false;
        dispatch('saved');
      }
    );
  };
</script>

<style style="text/scss" lang="scss">
  .step-title {
    text-align: center;
    font-size: 14px;
    line-height: 26px;
    font-weight: 500;
  }

  .ui-cancel {
    font-weight: 500;
    color: black;

    &:hover {
      opacity: 0.75;
    }
  }

  .updownarrow {
    transition: 0.2s;
  }

  .downarrow {
    transform: rotate(180deg);
  }
</style>

<div class="step-title">Customize thank you message</div>
<div style="margin-top: 60px">
  <div
    style="font-size: 15px; display: block; font-weight: normal; opacity: 0.5;
    padding-left: 60px;">
    Thank you message
  </div>
  <div style="margin-top: 20px; display: flex; align-items: flex-start;">
    {#if currentUser.avatar_url}
      <div style="flex-shrink: 0; padding-top: 10px; width: 32px; height: 42px;">
        <Avatar src={currentUser.avatar_url} size={32} user={currentUser} mobile={mobile} />
      </div>
    {/if}
    <div style="flex: 1; margin-left: 10px; margin-right: -20px;">
      <Textarea
        textareaStyle="padding: 10px; font-size: 14px; font-weight: 400;
        opacity: 1"
        bind:value={recRequest.thank_you_message}
        rows={null} />
    </div>
  </div>
</div>

<div style="margin-top: 40px; margin-left: auto; margin-right: auto; width: 275px">
  {#if saving}
    <Button text="<i class='fa fa-spin fa-spinner'></i>&nbsp;&nbsp;Saving" />
  {:else}
    <Button text="Next" on:click={save} />
  {/if}
  <div style="margin-top: 15px; display: block; text-align: center">
    <a href="#" class="ui-cancel" on:click={close}>Cancel</a>
  </div>
</div>
